var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#595959",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M.764 5.22v10.05c0 1.24 1.002 2.25 2.254 2.25h8.251c1.253 0 2.255-1.01 2.255-2.25V5.22M4.458 13.429L4.458 7.661M9.83 13.429L9.83 7.66M10.74 3.35v-.6c0-1.11-.8-2.03-1.862-2.21C8.747.51 8.617.5 8.487.5H5.802C4.82.5 3.988 1.13 3.678 2c-.081.23-.131.49-.131.75v.6M0 3.349L14.288 3.349",
  transform: "translate(-912 -149) translate(912 149) translate(2 1)"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export default ForwardRef;